<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <div
      v-if="hasAppliedOffer"
      class="cf-flex cf-flex--column cf-flex--gap-16"
    >
      <h4 class="cf-title cf-title--4">
        Applied Reward
      </h4>

      <cf-offer-card-details
        :offer="appliedOffer"
        button-content="Remove"
        @set-offer="removeOfferHandler"
      />
    </div>

    <button
      v-else-if="offers.length || userHasUnlockedThresholds"
      class="cf-button cf-button--tertiary cf-button--mobile-fill cf-padding-12"
      type="button"
      title="Add an Offer"
      @click.stop="goToLoyaltyPage"
    >
      + Add an Offer
    </button>

    <div
      v-else
      class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-16"
    >
      <span class="cf-icon cf-icon--medium far fa-gift" />

      <div class="cf-flex cf-flex--column cf-flex--gap-8">
        <h4 class="cf-title cf-title--4">
          {{ content.Loyalty.metadata.rewardsEmptyStateTagline }}
        </h4>

        <p class="cf-subtitle cf-subtitle--2">
          {{ content.Loyalty.metadata.rewardsEmptyStateMessage }}
        </p>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfOfferCardDetails from '../cf-offer-card-details/index.vue';

  export default {
    name: 'CfOffersCardList',

    components: {
      CfOfferCardDetails
    },

    props: {
      appliedOffer: {
        type: Object,
        default() {
          return {};
        }
      },

      offers: {
        type: Array,
        required: true
      }
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('locations', ['timeZone']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('offers', ['loyalty']),

      userHasUnlockedThresholds() {
        return !!this.loyalty.unlockedThresholds.length;
      },

      hasAppliedOffer() {
        return Object.keys(this.appliedOffer).length > 0;
      }
    },

    methods: {
      removeOfferHandler() {
        this.$emit('remove-offer');
      },

      goToLoyaltyPage() {
        this.$router.push({
          name: 'loyalty',
          query: {
            origin: this.$route.name
          }
        });
      }
    }
  };
</script>
